export default __webpack_public_path__ + "static/media/pp.c443dda0.png";